export enum IdOpc {
    'NaoObrigatorio' = 1,
    'Opcional' = 2,
    'Obrigatorio' = 3
}